var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardiomyopathyWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg38",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .st0 {\n        fill: #fff;\n      }\n      .st0, .st1 {\n        stroke: #000;\n        stroke-width: 1.5px;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n      .st1 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cardiomyopathy",
    transform: "translate(-55,-53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st11",
    clipPath: "url(#clippath-cw8)",
    id: "g29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 68.09,74.47 c -1.78,-1.55 -3.56,-3.1 -5.34,-4.66 -1.14,-1 -2.29,-2 -3.21,-3.21 -0.91,-1.21 -1.59,-2.66 -1.63,-4.18 -0.06,-2.28 1.41,-4.35 3.54,-5.1 2.23,-0.79 5.3,-0.52 6.72,2.6",
    id: "path29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5",
    clipPath: "url(#clippath-cw9)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 68.06,74.47 c 1.78,-1.55 3.56,-3.1 5.34,-4.66 1.14,-1 2.29,-2 3.21,-3.21 0.91,-1.21 1.59,-2.66 1.63,-4.18 0.06,-2.28 -1.41,-4.35 -3.54,-5.1 -2.23,-0.79 -5.3,-0.52 -6.72,2.6",
    id: "path30"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.08,70.56 73.33,62.81 68.58,70.56 ",
    id: "polygon31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 73.330002,
    y1: 66.309998,
    x2: 73.330002,
    y2: 67.059998,
    id: "line31"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 73.330002,
    cy: 68.75,
    r: 0.039999999,
    id: "circle31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "62.26 65.67 64.47 65.67 65.78 62.84 67.12 68.12 68.36 65.8 71.21 65.81",
    id: "polyline31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiomyopathyWarning);
export default __webpack_public_path__ + "static/media/CardiomyopathyWarning.c2a6c71214686027d2723bb17aa8164b.svg";
export { ForwardRef as ReactComponent };